export default __webpack_public_path__ + "static/media/plain-sticker-T.42082032.png";